import React from 'react';
import {
  AiOutlineBold,
  AiOutlineItalic,
  AiOutlineUnderline,
  AiOutlineUnorderedList,
  AiOutlineOrderedList,
} from 'react-icons/ai';

const inlineStyleTypes = [
  {
    inlineStyle: 'BOLD',
    tooltipTitle: 'Полужирный',
    content: <AiOutlineBold />,
  },
  {
    inlineStyle: 'ITALIC',
    tooltipTitle: 'Курсив',
    content: <AiOutlineItalic />,
  },
  {
    inlineStyle: 'UNDERLINE',
    tooltipTitle: 'Подчеркнутый',
    content: <AiOutlineUnderline />,
  },
];

const blockHeadingTypes = [
  {
    inlineStyle: 'header-one',
    tooltipTitle: 'Заголовок 1',
    content: 'H1',
  },
  {
    inlineStyle: 'header-two',
    tooltipTitle: 'Заголовок 2',
    content: 'H2',
  },
  {
    inlineStyle: 'header-three',
    tooltipTitle: 'Заголовок 3',
    content: 'H3',
  },
];

const blockListTypes = [
  {
    inlineStyle: 'unordered-list-item',
    tooltipTitle: 'Маркированный список',
    content: <AiOutlineUnorderedList />,
  },
  {
    inlineStyle: 'ordered-list-item',
    tooltipTitle: 'Нумерованный список',
    content: <AiOutlineOrderedList />,
  },
];

// константы для передачи в массив в туулбар
export const inlineStyle = 'INLINESTYLE';
export const blockHeading = 'BLOCKHEADING';
export const blockList = 'BLOCKLIST';
export const linkAdd = 'LINCADD';
export const phoneAdd = 'PHONEADD';
export const informationsLinkAdd = 'INFORMATIONSLINKADD';

// обьект для отрисовки необходимых функциональностей в туулбаре
export const objToolbar = {
  INLINESTYLE: inlineStyleTypes,
  BLOCKHEADING: blockHeadingTypes,
  BLOCKLIST: blockListTypes,
};

// начальное сосотояние для мобалки добавления ссылки
export const initEditorLinkModalData = {
  visible: false,
  url: '',
  text: '',
  editMode: false,
};

// начальное сосотояние для мобалки добавления внутренней ссылки
export const initEditorInformationsLinkModalData = {
  visible: false,
  url: '',
  text: '',
  editMode: false,
  internalLinkId: null,
};

// начальное состояние для модалки добавления телефона
export const initEditorPhoneModalData = {
  visible: false,
  phone: '',
  dopPhone: '',
  text: '',
  editMode: false,
};
